import { Component, OnInit, Input, Output, EventEmitter, Injector, ComponentFactoryResolver, ViewChild, OnChanges } from '@angular/core';
import { MessagerService } from '@farris/ui-messager';
import { NotifyService } from '@farris/ui-notify';
import { BsModalService } from '@farris/ui-modal';
import { ExpressioneditorComponent } from '../expressioneditor/expressioneditor.component';
import { EntityType, NavigationType, Schema } from '../common/Schema';
import { NewEntityType, NewNavigationType, NewSchema } from '../common/NewSchema';
import { ExpressionContextEntity, ExpressionEntity, InjectedEntity, InjectedType } from '../common/ExpressEntity';
import { AllOperator, StringOperator, NumberOperator, RelationOperator, LeftBracket, RightBracket, ColumnSize } from "../common/ComputeResource";
import { ComputeExpressUtils, ComputeTreeNode, ConditionRule, ConditionRuleView } from '../common/ComputeEntity';
import { ComputeLocalePipe } from '../utils/compute-local.pipe';
import { ExprFuncGridComponent } from '../expr-func-grid/expr-func-grid.component';
import { HttpClient } from '@angular/common/http';
import { CommonUtils } from '../utils/CommonUtils';

@Component({
  selector: 'svc-compute-rule',
  templateUrl: './compute-rule.component.html',
  styleUrls: ['./compute-rule.component.css'],
})
export class ComputeRuleComponent implements OnInit, OnChanges {

  @ViewChild("Function") Function: ExprFuncGridComponent;

  @Output() result = new EventEmitter<string>();
  @Output() closeModalEmitter = new EventEmitter<any>();
  @Input() contextEntity: ExpressionContextEntity = new ExpressionContextEntity;//表达式内部上下文
  @Input() conditions: ConditionRule[] = [{ computeField: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "" }];
  @Input() hideExpressButton: boolean = false;  //是否隐藏底部切换按钮
  @Input() advencedSetting: any = {};           //高级表达式setting
  @Input() ignoredOperators: any[] = [];         //隐藏的操作符
  @Input() allowSelectRoot: boolean = true;     //允许选中根节点

  constructor(private msgSer: MessagerService, private notifyService: NotifyService, private injector: Injector, private modalService: BsModalService, private compFactRes: ComponentFactoryResolver) {
    this.localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.local = new ComputeLocalePipe(this.localeId);
    this.notifies = {
      1: { type: 'success', msg: this.local.transform("Notice_Success") },
      2: { type: 'error', msg: this.local.transform("Notice_NotComplate") },
      3: { type: 'success', msg: this.local.transform("Notice_SuccessClear") },
      4: { type: 'warning', msg: this.local.transform("Notice_PleaseSelectRow") },
      5: { type: 'error', msg: this.local.transform("Notice_NotAllowSelectRoot") },
    };
    RelationOperator.forEach(x => { if (x.lang == this.localeId) { this.relaOpers = x.resource; } });
    AllOperator.forEach(x => { if (x.lang == this.localeId) { this.allOpers = x.resource; } })
    this.allOpers = this.allOpers.filter(x => !this.ignoredOperators.includes(x.value));
    StringOperator.forEach(x => { if (x.lang == this.localeId) { this.strOpers = x.resource; } })
    this.strOpers = this.strOpers.filter(x => !this.ignoredOperators.includes(x.value));
    NumberOperator.forEach(x => { if (x.lang == this.localeId) { this.numOpers = x.resource; } })
    this.numOpers = this.numOpers.filter(x => !this.ignoredOperators.includes(x.value));
    this.headers[0] = this.local.transform("Header_LeftBracket");
    this.headers[1] = this.local.transform("Headrt_Data");
    this.headers[2] = this.local.transform("Headrt_Operator");
    this.headers[3] = this.local.transform("Headrt_Value");
    this.headers[4] = this.local.transform("Headrt_RightBracket");
    this.headers[5] = this.local.transform("Headrt_Relation");
    this.buttons[0] = this.local.transform("Button_Advaned");
    this.buttons[1] = this.local.transform("Button_Save");
    this.buttons[2] = this.local.transform("Button_Reset");
    this.buttons[3] = this.local.transform("Button_Cancel");
    this.headButtons[0] = this.local.transform("HeadButton_Up");
    this.headButtons[1] = this.local.transform("HeadButton_Down");
    this.headButtons[2] = this.local.transform("HeadButton_Top");
    this.headButtons[3] = this.local.transform("HeadButton_Bottom");

    CommonUtils.init();
  }

  //国际化设置
  private localeId: string;
  private local: ComputeLocalePipe;
  private http: HttpClient;

  private oldId = 10001;                //为属性赋值id使用
  private newId = 20001;
  ColumnSize = ColumnSize;              //列长度
  LeftBracket = LeftBracket;            //左括号
  RightBracket = RightBracket;          //右括号
  relaOpers = [];                       //逻辑运算符
  allOpers = [];                        //全部操作符
  strOpers = [];                        //字符操作符
  numOpers = [];                        //数字操作符
  notifies = {};                        //提示信息
  headers = [];                         //表头
  buttons = [];                         //按钮
  headButtons = [];                     //表头按钮

  hideExpress: any;                     //通过样式来隐藏/展示切换高级表达式按钮
  entities = [];                        //实体列表
  propertyList: any;                    //Farris组件需要实体
  operators = [];                       //所有计算条件的操作符集合
  currentView: { index: number, condition: ConditionRuleView } = null;
  conditionViews: ConditionRuleView[] = []; //条件视图列表

  ngOnChanges() {
    this.allOpers = this.allOpers.filter(x => !this.ignoredOperators.includes(x.value));
    this.strOpers = this.strOpers.filter(x => !this.ignoredOperators.includes(x.value));
    this.numOpers = this.numOpers.filter(x => !this.ignoredOperators.includes(x.value));
  }

  ngOnInit() {
    if (this.Function != null && this.http == null) {
      this.http = this.Function.getHttp();
    }

    try {
      if (this.contextEntity.sexpr) {
        this.conditions = JSON.parse(this.contextEntity.sexpr) as ConditionRule[];
        if (this.conditions.length == 0) {
          this.conditions = [{ computeField: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "" }];
        }
      }
    } catch {
      this.conditions = [{ computeField: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "" }];
    }

    //转换Schema结构
    if (this.contextEntity.newSchemaMap != null && this.contextEntity.newSchemaMap.size > 0) {
      this.initNewSchema(this.contextEntity.injectedEntities, this.contextEntity.newSchemaMap);
    } else if (this.contextEntity.injectedEntities && this.contextEntity.injectedEntities.length > 0) {
      this.initSchema(this.contextEntity.injectedEntities, this.contextEntity.schemaMap);
    }

    this.conditionViews = this.toView(this.conditions);

    //初始化操作符集合
    if (this.entities.length > 0) {
      for (let index in this.conditions) {
        this.operators[index] = this.allOpers;
        for (let entity of this.entities) {
          if (entity.chainCode == this.conditions[index].computeField) {
            if (entity.type == "String" || entity.type == "Date" || entity.type == "DateTime")
              this.operators[index] = this.strOpers;
            else if (entity.type == "Decimal" || entity.type == "Integer" || entity.type == "Byte" || entity.type == "Binary")
              this.operators[index] = this.numOpers;
            else
              this.operators[index] = this.allOpers;
            break;
          }
        }
      }
    }
    this.operators = [...this.operators];

    //字段选择
    this.propertyList = {
      columns: [
        { "field": "code", "title": this.local.transform("Data_Code"), "width": 130, "hAlign": "left", "align": "left", "formatter": null },
        { "field": "name", "title": this.local.transform("Data_Name"), "width": 130, "hAlign": "left", "align": "left", "formatter": null }
      ],
      items: this.entities,
      treeInfo: {
        "loadDataType": "all", "layerType": "pathcode", "dataField": "treeInfo", "pathField": "path", "layerField": "layer", "isDetailField": "isDetail", "onlySelectLeaf": false, "parentField": "parentElement", "treeDataIsInit": false
      },
      displayType: "TreeList"
    };

    //切换高级表达式按钮（展示/隐藏）
    if (this.hideExpressButton) this.hideExpress = { display: 'none' };
    else this.hideExpress = { display: 'block' };
  }

  //新增和删除条件
  insert(index: number) {
    this.conditionViews.splice(index + 1, 0, { computeField: '', fieldName: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "", sysorgData: { showText: "", bindingData: { id: "", name: "" } } });
    this.operators.splice(index + 1, 0, this.allOpers); //操作符集合调整
    this.operators = [...this.operators];
  }
  remove(index: number) {
    let line = index + 1;
    this.msgSer.confirm(this.local.transform("DeleteConfirmLeft") + line + this.local.transform("DeleteConfirmRight")).subscribe((result) => {
      if (result) {
        if (index != 0) {
          // 删除 非第1行
          this.conditionViews.splice(index, 1);
          this.operators.splice(index, 1);
        } else if (this.conditionViews.length > 1) {
          // 删除 第1行，但当前条件数量大于1
          this.conditionViews.splice(index, 1);
          this.operators.splice(index, 1);
        } else {
          // 删除 第1行，当前只有第1行条件
          this.conditionViews = [{ computeField: '', fieldName: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "", sysorgData: { showText: "", bindingData: { id: "", name: "" } } }]
          this.conditions = [{ computeField: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "" }];
          this.operators = [];
          this.operators.push(this.allOpers);
          this.operators = [...this.operators];
          this.notifyService[this.notifies['3'].type]({ msg: this.notifies['3'].msg });
        }
        if (this.currentView && index === this.currentView.index) {
          this.currentView = null;
        }
      }
    });
  }

  //条件选中事件
  selected($event) {
    this.currentView = $event;
  }
  isSelected($event: number) {
    return this.currentView != null ? this.currentView.index === $event : false;
  }

  //farris控件变量变更事件
  selectChange($event) {
    let index = $event.index;
    let oldOperation = this.conditionViews[index].operator;

    // 禁止选中根节点
    if (!this.allowSelectRoot && !String($event.data.data.chainCode).includes(".")) {
      this.notifyService[this.notifies['5'].type]({ msg: this.notifies['5'].msg });

      let that = this;
      setTimeout(() => {
        that.conditionViews[index].computeField = "";
        that.conditionViews[index].fieldName = "";
      }, 300)
      return;
    }

    //绑定变量的Code
    this.conditionViews[index].computeField = $event.data.data.chainCode;

    if ($event.data.data.type == "String" || $event.data.data.type == "Date" || $event.data.data.type == "DateTime") {
      this.operators[index] = this.strOpers;
      if (this.operators[index].filter(x => { return x.value == oldOperation }).length > 0) {
        this.conditionViews[index].operator = oldOperation;
      } else {
        //由于控件默认会展示第一个，所以此处设置第一个。如果此处不赋值的话，页面看起来没有错。但实际是没有值的
        this.conditionViews[index].operator = this.strOpers[0].value;
      }
    } else if ($event.data.data.type == "Decimal" || $event.data.data.type == "Integer" || $event.data.data.type == "Byte" || $event.data.data.type == "Binary") {
      this.operators[index] = this.numOpers;
      if (this.operators[index].filter(x => { return x.value == oldOperation }).length > 0) {
        this.conditionViews[index].operator = oldOperation;
      } else {
        //由于控件默认会展示第一个，所以此处设置第一个。如果此处不赋值的话，页面看起来没有错。但实际是没有值的
        this.conditionViews[index].operator = this.numOpers[0].value;
      }
    } else {
      this.operators[index] = this.allOpers;
      if (this.operators[index].filter(x => { return x.value == oldOperation }).length > 0) {
        this.conditionViews[index].operator = oldOperation;
      } else {
        //由于控件默认会展示第一个，所以此处设置第一个。如果此处不赋值的话，页面看起来没有错。但实际是没有值的
        this.conditionViews[index].operator = this.allOpers[0].value;
      }
    }
    this.operators = [...this.operators];
  }
  //移除某一行变量
  selectRemove($event) {
    this.conditionViews[$event.index].computeField = "";
  }
  //上下移动
  toTop() {
    if (this.isSelectRow()) {
      this.conditionViews.unshift(this.currentView.condition);
      this.conditionViews.splice(this.currentView.index + 1, 1);
      this.operators.unshift(this.operators[this.currentView.index]);
      this.operators.splice(this.currentView.index + 1, 1);

      this.currentView.index = 0;
      this.operators = [...this.operators];
    }
  }
  toUp() {
    if (this.isSelectRow()) {
      if (this.currentView.index == 0) return;
      else if (this.currentView) {
        let index = this.currentView.index;
        let tempArr = this.conditionViews.splice(index, 1);
        let tempOper = this.operators.splice(index, 1);
        this.conditionViews.splice(index - 1, 0, ...tempArr);
        this.operators.splice(index - 1, 0, ...tempOper);

        this.currentView.index = index - 1;
        this.operators = [...this.operators];
      }
    }
  }
  toDown() {
    if (this.isSelectRow()) {
      if (this.currentView.index >= this.conditionViews.length - 1) return;
      else if (this.currentView) {
        let index = this.currentView.index;
        let tempArr = this.conditionViews.splice(index, 1);
        let tempOper = this.operators.splice(index, 1);
        this.conditionViews.splice(index + 1, 0, ...tempArr);
        this.operators.splice(index + 1, 0, ...tempOper);

        this.currentView.index = index + 1;
        this.operators = [...this.operators];
      }
    }
  }
  toBottom() {
    if (this.isSelectRow()) {
      this.conditionViews.push(this.currentView.condition);
      this.conditionViews.splice(this.currentView.index, 1);
      this.operators.push(this.operators[this.currentView.index]);
      this.operators.splice(this.currentView.index, 1);

      this.currentView.index = this.conditionViews.length - 1;
      this.operators = [...this.operators];
    }
  }
  // 上下移动时，先判断是否选中某行
  private isSelectRow(): boolean {
    if (this.currentView == null) {
      this.notifyService[this.notifies['4'].type]({ msg: this.notifies['4'].msg });

      return false;
    }
    return true;
  }

  /**确认 */
  confirm() {
    let expression = new ExpressionEntity();
    let dds = this.toData(this.conditionViews);
    expression.expr = ComputeExpressUtils.convertExpr(dds);
    if (expression.expr == "") {
      //处理条件为空
      this.result.emit(null);
    }
    expression.sexpr = JSON.stringify(dds);
    this.result.emit(JSON.stringify(expression));
    this.closeModalEmitter.emit("close");
  }
  /**重置 */
  reset() {
    this.conditionViews = [
      { computeField: '', fieldName: '', value: '', lbracket: '(', rbracket: ')', relation: "&&", operator: "", sysorgData: { showText: "", bindingData: { id: "", name: "" } } }
    ];
  }
  /**取消 */
  cancle() {
    this.closeModalEmitter.emit("close");
  }

  /**打开高级表达式 */
  openAdvancedExpression() {
    let that = this;
    this.openAdvancedExpr().then(
      expre => {
        that.result.emit(expre as string);
      }
    );
    this.closeModalEmitter.emit("close");
  }
  openAdvancedExpr() {
    let that = this;
    return new Promise(
      function (resolve) {
        const compFactory = that.compFactRes.resolveComponentFactory(ExpressioneditorComponent);
        const compRef = compFactory.create(that.injector);
        compRef.instance.expressionEntity = that.contextEntity;
        compRef.instance.setting = that.advencedSetting;
        compRef.instance.expressionEntity.expr = ComputeExpressUtils.convertExpr(that.conditionViews);
        compRef.instance.expressionEntity.sexpr = "";
        let dialog = that.modalService.show(compRef, {
          title: that.local.transform("AdvancedExpression"),
          width: 1325.5,
          height: 728,
          buttons: [
            {
              text: that.local.transform("Advanced_Cancel"), cls: 'btn btn-secondary', handle: () => {
                dialog.close();
              }
            },
            {
              text: that.local.transform("Advanced_Save"), cls: 'btn btn-primary', handle: () => {
                compRef.instance.getExprWithCheck().then(res => {
                  if (res.closeable) {
                    compRef.instance.result.emit(res.expression);
                    dialog.close();
                  }
                });
              }
            }
          ],
          showButtons: true
        });
        compRef.instance.result.subscribe((expressionContent) => {
          return resolve(expressionContent);
        });
      })
  }

  //Schema功能方法
  //旧Schema转化
  private initSchema(injectedEntities: InjectedEntity[], schema: Map<string, Schema>) {
    if (injectedEntities && injectedEntities.length > 0) {
      this.entities = [];
      //实体显示禁忌表
      let navigatorMap = new Map<string, InjectedType>();
      let numcount = 1;
      //解析每一个注入实体，将其转化为TreeNode
      injectedEntities.forEach(injectEntity => {

        //根据schema名称找到对应的schema
        let currentSchema = schema.get(injectEntity.schemaName);
        switch (injectEntity.injectedType) {
          //注入的若为实体集
          case InjectedType.EntitySet: {
          }; break;
          //注入的若为实体类型
          case InjectedType.EntityType: {
            let entityType = currentSchema.entityTypes.find(entityType => entityType.name == injectEntity.injectedName);
            this.initEntityType(entityType, null, currentSchema, navigatorMap, numcount);
          }; break;
        }
        numcount++;
      });
    }

  }
  //旧EntityType转化
  private initEntityType(entityType: EntityType, parent: ComputeTreeNode, schema: Schema, navigatorMap: any, pathNum: any) {
    if (entityType) {
      let child = new ComputeTreeNode;  //子节点
      child.id = this.oldId++;
      child.code = entityType.name;
      child.name = entityType.description;
      child.chainCode = entityType.name;
      child.chainName = entityType.description;
      child.type = "Type";
      if (parent) {
        child.parentId = parent.id;
        child.chainCode = parent.chainCode + "." + entityType.name;
        child.chainName = parent.chainName + "." + entityType.description;
        child.treeInfo.layer = parent.treeInfo.layer + 1;
        child.treeInfo.path = parent.treeInfo.path + ComputeExpressUtils.getPath(pathNum);
      } else {
        child.parentId = null;
        child.treeInfo.layer = 1;
        child.treeInfo.path = ComputeExpressUtils.getPath(1);
      }
      child.data = { chainName: "" };
      this.entities.push(child);

      //将转化的entitytype添加进禁忌表
      navigatorMap.set(entityType.name + entityType.id, InjectedType.EntityType);
      //将每个属性转化为每个TreeNode
      let propertyNum = 1;
      entityType.properties.forEach(property => {
        let leaf = new ComputeTreeNode; //叶子节点
        leaf.id = this.oldId++;
        leaf.code = property.name;
        leaf.name = property.description;
        leaf.chainCode = child.chainCode + "." + property.name;
        leaf.chainName = child.chainName + "." + property.description;
        leaf.type = property.type;
        leaf.treeInfo.layer = child.treeInfo.layer + 1;
        leaf.treeInfo.path = child.treeInfo.path + ComputeExpressUtils.getPath(propertyNum);
        propertyNum++;
        leaf.parentId = child.id;
        leaf.data = { chainName: "" };
        this.entities.push(leaf);
      });
      entityType.navigationProperties.forEach(navigationProperty => {
        //判断是否导航属性对应的名称在禁忌表中
        if (!(navigatorMap.get(navigationProperty.name + navigationProperty.navigationId))) {
          if (navigationProperty.type == NavigationType.EntitySet) {
          }//若为实体类型
          else if (navigationProperty.type == NavigationType.EntityType) {
            let entityType = schema.entityTypes.find(entitytype => entitytype.id == navigationProperty.navigationId && entitytype.name == navigationProperty.name);
            this.initEntityType(entityType, child, schema, navigatorMap, propertyNum + 1)
          }
        } else {
          //若导航属性在禁忌表中
          let navigatortree = new ComputeTreeNode;
          navigatortree.id = this.oldId++;
          navigatortree.code = navigationProperty.name;
          navigatortree.name = navigationProperty.description;
          navigatortree.chainCode = child.chainCode + "." + navigationProperty.name;
          navigatortree.chainName = child.chainName + "." + navigationProperty.description;
          navigatortree.type = navigationProperty.type.toString();
          navigatortree.treeInfo.layer = child.treeInfo.layer + 1;;
          navigatortree.treeInfo.path = child.treeInfo.path + ComputeExpressUtils.getPath(propertyNum);
          navigatortree.parentId = child.id;
          navigatortree.data = { chainName: "" };
          this.entities.push(navigatortree);
        }
        propertyNum++;
      });
    }
    //若entitytype为空或未定义
    else return null;
  }
  //新NewSchema转化
  private initNewSchema(injectedEntities: InjectedEntity[], schemaMap: Map<string, NewSchema>) {
    if (injectedEntities && injectedEntities.length > 0) {
      this.entities = [];
      //实体显示禁忌表
      let navigatorMap = new Map<string, InjectedType>();
      let numcount = 1;
      //解析每一个注入实体，将其转化为TreeNode
      injectedEntities.forEach(injectEntity => {
        //根据schema名称找到对应的schema
        let currentSchema = schemaMap.get(injectEntity.schemaName);
        switch (injectEntity.injectedType) {
          //注入的若为实体集
          case InjectedType.EntitySet: {
          }; break;
          //注入的若为实体类型
          case InjectedType.EntityType: {
            let entityType = currentSchema.entityTypes.find(type => type.code == injectEntity.injectedName);
            this.initNewEntityType(entityType, null, currentSchema, navigatorMap, numcount);
          }; break;
        }
        numcount++;
      });
    }
  }
  //新NewEntityType转化
  private initNewEntityType(entityType: NewEntityType, parent: ComputeTreeNode, schema: NewSchema, navigatorMap: any, pathNum: any) {
    if (entityType) {
      let child = new ComputeTreeNode;  //子节点
      child.id = this.newId++;
      child.code = entityType.code;
      child.name = entityType.name;
      child.chainCode = entityType.code;
      child.chainName = entityType.name;
      child.type = "Type";
      if (parent) {
        child.parentId = parent.id;
        child.chainCode = parent.chainCode + "." + entityType.code;
        child.chainName = parent.chainName + "." + entityType.name;
        child.treeInfo.layer = parent.treeInfo.layer + 1;
        child.treeInfo.path = parent.treeInfo.path + ComputeExpressUtils.getPath(pathNum);
      } else {
        child.parentId = null;
        child.treeInfo.layer = 1;
        child.treeInfo.path = ComputeExpressUtils.getPath(1);
      }
      child.data = { chainName: "" };
      this.entities.push(child);

      //将转化的entitytype添加进禁忌表
      navigatorMap.set(entityType.code + entityType.name, InjectedType.EntityType);
      //将每个属性转化为每个TreeNode
      let propertyNum = 1;
      entityType.properties.forEach(property => {
        let leaf = new ComputeTreeNode; //叶子节点
        leaf.id = this.newId++;
        leaf.code = property.code;
        leaf.name = property.name;
        leaf.chainCode = child.chainCode + "." + property.code;
        leaf.chainName = child.chainName + "." + property.name;
        leaf.type = property.dataType;
        leaf.treeInfo.layer = child.treeInfo.layer + 1;
        leaf.treeInfo.path = child.treeInfo.path + ComputeExpressUtils.getPath(propertyNum);
        propertyNum++;
        leaf.parentId = child.id;
        leaf.data = { chainName: "" };
        this.entities.push(leaf);
      });
      entityType.navigationProperties.forEach(navigationProperty => {
        //判断是否导航属性对应的名称在禁忌表中
        if (!(navigatorMap.get(navigationProperty.code + navigationProperty.navigationName))) {
          if (navigationProperty.navigationType == NewNavigationType.EntitySet) {
          } else if (navigationProperty.navigationType == NewNavigationType.EntityType) {
            //若为实体类型
            let entityType = schema.entityTypes.find(type => type.code == navigationProperty.navigationName);
            this.initNewEntityType(entityType, child, schema, navigatorMap, propertyNum + 1)
          }
        } else {
          //若导航属性在禁忌表中
          let navigatortree = new ComputeTreeNode;
          navigatortree.id = this.newId++;
          navigatortree.code = navigationProperty.code;
          navigatortree.name = navigationProperty.name;
          navigatortree.chainCode = child.chainCode + "." + navigationProperty.code;
          navigatortree.chainName = child.chainName + "." + navigationProperty.name;
          navigatortree.type = navigationProperty.navigationType;
          navigatortree.treeInfo.layer = child.treeInfo.layer + 1;;
          navigatortree.treeInfo.path = child.treeInfo.path + ComputeExpressUtils.getPath(propertyNum);
          navigatortree.parentId = child.id;
          navigatortree.data = { chainName: "" };
          this.entities.push(navigatortree);
        }
        propertyNum++;
      });
    }
    //若entitytype为空或未定义
    else return null;
  }

  //组织确定事件
  afterSelectSysorg($event) {
    let index = $event.index;
    this.conditionViews[index].value = "";
    if ($event.orgs.length > 0) {
      for (let org of $event.orgs) {
        this.conditionViews[index].value = (this.conditionViews[index].value == "" ? org.id : this.conditionViews[index].value + "," + org.id);
      }
    }
  }

  private toView(datas: ConditionRule[]): ConditionRuleView[] {
    let views: ConditionRuleView[] = [];
    if (datas != null && datas.length > 0) {
      for (let i in datas) {
        views[i] = {
          computeField: datas[i].computeField,
          fieldName: datas[i].computeField,
          value: datas[i].value,
          sysorgData: { showText: datas[i].value, bindingData: { id: "", name: "" } },
          operator: datas[i].operator,
          lbracket: datas[i].lbracket,
          rbracket: datas[i].rbracket,
          relation: datas[i].relation
        };
        //变量Code替换为Name
        if (this.entities && this.entities.length > 0) {
          for (let d of this.entities) {
            if (views[i].computeField == d.chainCode) {
              views[i].fieldName = d.chainName;
              break;
            }
          }
        }
        //组织从属
        if (views[i].operator == "OrgAffiliation") {
          let orgIds = views[i].value.split(",");
          this.http.post(CommonUtils.convertPath("/api/runtime/sys/v1.0/expressextend/orgNames"), orgIds).toPromise().then(res => {
            views[i].sysorgData.showText = (res as any).names;
            let nameList = (res as any).names.split(",")
            for (let j in orgIds) {
              views[i].sysorgData.bindingData.id = (views[i].sysorgData.bindingData.id == "" ? orgIds[j] : views[i].sysorgData.bindingData.id + "," + orgIds[j]);
              views[i].sysorgData.bindingData.name = (views[i].sysorgData.bindingData.name == "" ? nameList[i] : views[i].sysorgData.bindingData.name + "," + nameList[i]);
            }
          }).catch(() => {
          })
        }
      }
    }

    return views;
  }

  private toData(views: ConditionRuleView[]): ConditionRule[] {
    let datas: ConditionRule[] = [];
    if (views != null && views.length > 0) {
      for (let i in views) {
        datas[i] = {
          computeField: views[i].computeField,
          value: views[i].operator == "==null" || views[i].operator == "!=null" ? null : views[i].value,
          operator: views[i].operator,
          lbracket: views[i].lbracket,
          rbracket: views[i].rbracket,
          relation: views[i].relation
        };
      }
    }

    return datas;
  }
}
